import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { PROD } from '../../../common/constants';
import { Container, Button, Stack, TextField, Typography, Grid, RadioGroup, Radio, FormControl, FormControlLabel, FormLabel, InputLabel, } from '@mui/material';
import BackButton from '../../../common/backButton';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { v4 as uuidv4 } from 'uuid';
import { VALIDATION, capitalizeFunction, openTextFieldMaxLength } from "../../../common/commonValidations";
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { processMultipleWorkFlow } from "../seeAllWorkList/workListAPIs";
import { format } from 'date-fns';
import { useTranslation } from "react-i18next";

function VerifyStakeHolderMapping() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [workFlowArr, setWorkFlowArr] = useState([]);
  const [mappingWorkflowResponse, setMappingWorkflowResponse] = useState();
  const stakeHolderMappingDetails = state?.workFlowRequestDetails?.stakeholderDtlsLst;
  const workflowDetails = state?.workFlowRequestDetails?.stakeholderDtlsLst[0].workflowRqstDtls;
  const [comment, setComment] = useState();
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [errorMessage, setErrorMessage] = useState(
    {
      commentError: ""
    }
  );

  useEffect(() => {
    const tempApprovalArr = [];
    stakeHolderMappingDetails?.map((item) => {
      tempApprovalArr.push({ remarks: '', action: null, applicationNumber: item?.applicationNumber });
    });
    setWorkFlowArr(tempApprovalArr);
  }, [stakeHolderMappingDetails]);

  const commentColumns = [
    { field: 'previousStepUser', headerName: "User", width: 300 },
    { field: 'previousStepComments', headerName: "Comment", width: 650 },
  ]
  const columns = [
    { field: 'mappingType', headerName: 'Route Type', width: 190, hide: !stakeHolderMappingDetails[0]?.transporterUrn },
    { field: 'sourceStakeholderType', headerName: 'Map From', hide: stakeHolderMappingDetails[0]?.transporterUrn },
    { field: 'sourceStakeholderUrn', headerName: 'From URN', width: 190 },
    { field: 'sourceStakeholderName', headerName: 'From Name', width: 200 },
    { field: 'landName', headerName: 'Land Name', width: 190, hide: stakeHolderMappingDetails[0]?.sourceStakeholderType !== "Grower" },
    {
      field: 'transporterNameAndUrn', headerName: 'Transporter', renderCell: (params) => {
        return (
          params?.row?.transporterName + "(" + params?.row?.transporterUrn + ")"
        )
      }, hide: !stakeHolderMappingDetails[0]?.transporterUrn
    },
    { field: 'targetStakeholderType', headerName: 'Map To', width: 190, hide: stakeHolderMappingDetails[0]?.transporterUrn },
    { field: 'targetStakeholderUrn', headerName: 'To URN', width: 200 },
    { field: 'targetStakeholderName', headerName: 'To Name', width: 190 },
    { field: 'distance', headerName: 'Distance(in KM)', hide: stakeHolderMappingDetails[0]?.sourceStakeholderType !== "Grower" && stakeHolderMappingDetails[0]?.targetStakeholderType !== "LLE" },
    {
      field: 'actions', headerName: 'Actions', width: 450, hide: state?.type !== "all" ? true : false, 
      renderCell: (params) => {
        return (
          <>
            {params?.row?.workflowRqstDtls?.previousStepAction === "Seek_Clarification" ?
              <>
                <FormControl>
                  <RadioGroup
                    row
                    name="radio-buttons-group1"
                  >
                    <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Mapping_Clarification"
                      checked={workFlowArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Mapping_Clarification"}
                      onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Provide Clarification" />
                  </RadioGroup>
                </FormControl>
              </> :
              <>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group2"
                  >
                    <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Approved"
                      checked={workFlowArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Approved"}
                      onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Approve" />
                    <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Rejected"
                      checked={workFlowArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Rejected"}
                      onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Reject" />
                    <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Seek_Clarification"
                      checked={workFlowArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Seek_Clarification"}
                      onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Seek for clarification" />
                  </RadioGroup>
                </FormControl>
              </>
            }
          </>
        )
      }
    }
  ]

  useEffect(() => {
    if (mappingWorkflowResponse) {
      if (mappingWorkflowResponse?.status === "SUCCESS") {
        toast.success(mappingWorkflowResponse?.description)
        navigate(-1);
      }
      else {
        toast.error(mappingWorkflowResponse?.description)
      }
    }
  }, [mappingWorkflowResponse]);

  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    const tempWorFlowArr = workFlowArr.map(item => {
      item.remarks = comment
      return item
    });
    console.log("tempWorFlowArr", tempWorFlowArr);
    processMultipleWorkFlow(tempWorFlowArr, setMappingWorkflowResponse)
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const radioChange = (e, applicationNumber) => {
    const tempArr = (workFlowArr?.map(item => {
      if (item?.applicationNumber === applicationNumber) {
        item.action = e.target.value
      }
      return item;
    }
    ))
    setWorkFlowArr(tempArr);
  }

  const onAllClick = (actionType) => {
    const tempApprovalArr = (workFlowArr?.map(item => {
      item.action = actionType
      return item;
    }
    ))
    setWorkFlowArr(tempApprovalArr);
  }

  const onSubmit = () => {
    if (!comment) {
      setErrorMessage({ ...errorMessage, commentError: "Please enter comment" })
    }
    else if (workFlowArr.some(item => item.action === null)) {
      toast.error("Please act on all applications")
    }
    else {
      handleConfirmLogModalOpen();
    }
  }

  const handleChange = (e) => {
    setComment(VALIDATION.noSpecialCharacterValidation(e.target.value));
    setErrorMessage({ ...errorMessage, commentError: "" })
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES12</p>}
        <Grid item xs={12} lg={8}>
          <Stack direction="row" alignItems="center" spacing={1} mb={1}>
            <BackButton navigate={navigate} />
            <Typography variant="h5" gutterBottom>
              Verify Stakeholder Mapping
            </Typography>
          </Stack>
        </Grid>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
            Assignment-Operation: {stakeHolderMappingDetails[0]?.workflowRqstDtls?.operation}, Request No/Approval Note No: {stakeHolderMappingDetails?.[0]?.requestNumber}, Date: {format(new Date(stakeHolderMappingDetails?.[0]?.createdOn), 'dd/MM/yyyy')}
          </Typography>
        </Stack>
        {console.log("stakeHolderMappingDetails", stakeHolderMappingDetails)}
        <DataGrid autoHeight
          rows={stakeHolderMappingDetails.map((item) => ({ ...item, id: uuidv4() }))}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          getRowId={(row) => row?.id}
        // components={{
        //   Toolbar: () => <CustomDataGridToolbar  rows={[stakeHolderMappingDetails]}
        //   columns={columns} fileName="mappingList.xlsx" />,
        // }}
        />
        <Grid container spacing={1}>
          <Grid item xs={12} lg={8}>
            {state?.type === "all" && <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
              <TextField fullWidth
                multiline
                error={errorMessage.commentError}
                helperText={errorMessage.commentError}
                maxRows={5}
                inputProps={{
                  maxLength: openTextFieldMaxLength,
                  // style: { textTransform: "capitalize" }
                }}
                rows={2}
                value={comment}
                label="Add Comment"
                onChange={(e) => handleChange(e)}
                sx={{ mt: 2 }}
              />
            </FormControl>}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">
              {t('reg.commentHistory')}
            </Typography>
            <DataGrid autoHeight
              rows={workflowDetails?.workflowCommentHistory ? workflowDetails?.workflowCommentHistory.map((commentItem) => ({ ...commentItem, id: uuidv4() })) : []}
              columns={commentColumns}
              pageSize={10}
              getRowId={(row) => row?.applicationNumber}
            />
          </Grid>
        </Grid>
        {(state?.type !== "sent" && state?.type !== "actionTaken") &&
          <Grid item xs={12} md={12} spacing={1} display='flex' justifyContent="flex-end">
            {stakeHolderMappingDetails?.some(item1 => item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification") &&
              <>
                <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick("Seek_Clarification")}>Seek clarification for All</Button>
                <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick("Rejected")}>Reject All</Button>
                <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick("Approved")}>Approve All</Button>
              </>}
            {stakeHolderMappingDetails?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification") &&
              <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick("Mapping_Clarification")}>Provide Clarification for All</Button>
            }
            <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onSubmit(e)}>Submit</Button>
          </Grid>}
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Submit" />

    </>
  );
}
export default VerifyStakeHolderMapping;
